import "core-js/modules/es.array.push.js";
export default {
  name: 'ActivityPage',
  methods: {
    goDetail: function goDetail(id) {
      // H5 项目使用 Vue Router 是对的
      this.$router.push({
        path: '/details',
        query: {
          id: id
        }
      });
    },
    goHome: function goHome() {
      this.$router.push('/');
    }
  }
};